import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
} from '@spartacus/core';
import { SelectWhsPopupComponent } from './select-whs-popup.component';
import { SelectWhsPopupGuard } from './services/guards/select-whs-popup.guard';

@NgModule({
  declarations: [SelectWhsPopupComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SwitchWhsPopupComponent: {
          component: SelectWhsPopupComponent,
          guards: [AuthGuard, SelectWhsPopupGuard],
        },
      },
    } as CmsConfig),
    FormsModule,
    I18nModule,
  ],
  exports: [SelectWhsPopupComponent],
})
export class SelectWhsPopupModule {}
